import { goJoinEvent } from "@/lobby_common/utils/utils.js";
export default {
  name: "mode3",
  components: {},
  data() {
    return {
      cur_left: 0,
      max_left: 0,
      num: 1,
      timer: null,
      content_index: undefined,
      showPoster: true
    };
  },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    getImgHeight() {
      const containerWidth =
        document.body.clientWidth > 1340
          ? 1280
          : document.body.clientWidth - 60;
      const num = 200 / 1340;
      return containerWidth * num;
    },
    arrContent() {
      const arr = [];
      this.item.list.map((v, i) => {
        if (v.isShow !== 0) {
          arr.push({
            ...v,
            eid: `101_17_${this.curindex}_${i}`,
          });
        }
      });
      this.content_index = this.curindex;
      if (arr.length % this.num > 0) {
        // 不能整除
        this.max_left = Math.floor(arr.length / this.num) * 100;
      } else {
        // 能整除
        this.max_left = (Math.floor(arr.length / this.num) - 1) * 100;
      }

      return [...arr];
    },
    lang() {
      return this.$store.getters.getLang;
    },
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config?.titleAlignment
    },
  },
  watch: {},
  async created() {},
  mounted() {
    // console.log(this.arrContent, 'arrContent')
  },
  methods: {
    changePosition(dir = "left") {
      const that = this;
      const dom = document.querySelector(`.content_${this.curindex}`);
      if (dom) {
        const target =
          dir === "left" ? that.cur_left - 100 : that.cur_left + 100;
        // if(that.cur_left === 0) dom.style.left = 0
        // else dom.style.left = `-${that.cur_left}00%`

        this.animateDom(target, dom, dir);
      }
    },
    animateDom(target, dom, dir) {
      const that = this;
      if (that.timer) {
        return false;
      }
      // let timer = that.timer;
      that.timer = setInterval(function () {
        const speed = dir === "left" ? -5 : 5; // 判断是向左走（负）还是向右走（正）
        // console.log(dir, that.cur_left, target)
        if (that.cur_left === target) {
          clearInterval(that.timer);
          that.timer = null;
        } else {
          that.cur_left = that.cur_left + speed;
          if (that.cur_left === 0) dom.style.left = 0;
          else dom.style.left = `-${that.cur_left}%`;
        }
      }, 10);
    },
    handelClick(item) {
      this.$eventPost("click", {
        eid: item.eid,
        jump_value: item.jump,
        time: Date.now(),
      });
      goJoinEvent(item.jump);
    },
  },
  activated() {
    setTimeout(() => {
      const video = document.getElementById('background-video1')
      if (video && video.paused) {
        video.play().catch(err => {
          console.warn('路由切换后播放失败:', err)
        })
      }
    }, 100)
  }
};
